var map = {
	"./square/ac.svg": 1714,
	"./square/ad.svg": 1715,
	"./square/ae.svg": 1716,
	"./square/af.svg": 1717,
	"./square/ag.svg": 1718,
	"./square/ai.svg": 1719,
	"./square/al.svg": 1720,
	"./square/am.svg": 1721,
	"./square/ao.svg": 1722,
	"./square/aq.svg": 1723,
	"./square/ar.svg": 1724,
	"./square/as.svg": 1725,
	"./square/at.svg": 1726,
	"./square/au.svg": 1727,
	"./square/aw.svg": 1728,
	"./square/ax.svg": 1729,
	"./square/az.svg": 1730,
	"./square/ba.svg": 1731,
	"./square/bb.svg": 1732,
	"./square/bd.svg": 1733,
	"./square/be.svg": 1734,
	"./square/bf.svg": 1735,
	"./square/bg.svg": 1736,
	"./square/bh.svg": 1737,
	"./square/bi.svg": 1738,
	"./square/bj.svg": 1739,
	"./square/bl.svg": 1740,
	"./square/bm.svg": 1741,
	"./square/bn.svg": 1742,
	"./square/bo.svg": 1743,
	"./square/bq.svg": 1744,
	"./square/br.svg": 1745,
	"./square/bs.svg": 1746,
	"./square/bt.svg": 1747,
	"./square/bv.svg": 1748,
	"./square/bw.svg": 1749,
	"./square/by.svg": 1750,
	"./square/bz.svg": 1751,
	"./square/ca.svg": 1752,
	"./square/cc.svg": 1753,
	"./square/cd.svg": 1754,
	"./square/cefta.svg": 1755,
	"./square/cf.svg": 1756,
	"./square/cg.svg": 1757,
	"./square/ch.svg": 1758,
	"./square/ci.svg": 1759,
	"./square/ck.svg": 1760,
	"./square/cl.svg": 1761,
	"./square/cm.svg": 1762,
	"./square/cn.svg": 1763,
	"./square/co.svg": 1764,
	"./square/cp.svg": 1765,
	"./square/cr.svg": 1766,
	"./square/cu.svg": 1767,
	"./square/cv.svg": 1768,
	"./square/cw.svg": 1769,
	"./square/cx.svg": 1770,
	"./square/cy.svg": 1771,
	"./square/cz.svg": 1772,
	"./square/de.svg": 1773,
	"./square/dg.svg": 1774,
	"./square/dj.svg": 1775,
	"./square/dk.svg": 1776,
	"./square/dm.svg": 1777,
	"./square/do.svg": 1778,
	"./square/dz.svg": 1779,
	"./square/ea.svg": 1780,
	"./square/ec.svg": 1781,
	"./square/ee.svg": 1782,
	"./square/eg.svg": 1783,
	"./square/eh.svg": 1784,
	"./square/er.svg": 1785,
	"./square/es-ct.svg": 1786,
	"./square/es-ga.svg": 1787,
	"./square/es.svg": 1788,
	"./square/et.svg": 1789,
	"./square/eu.svg": 1790,
	"./square/fi.svg": 1791,
	"./square/fj.svg": 1792,
	"./square/fk.svg": 1793,
	"./square/fm.svg": 1794,
	"./square/fo.svg": 1795,
	"./square/fr.svg": 1796,
	"./square/ga.svg": 1797,
	"./square/gb-eng.svg": 1798,
	"./square/gb-nir.svg": 1799,
	"./square/gb-sct.svg": 1800,
	"./square/gb-wls.svg": 1801,
	"./square/gb.svg": 1802,
	"./square/gd.svg": 1803,
	"./square/ge.svg": 1804,
	"./square/gf.svg": 1805,
	"./square/gg.svg": 1806,
	"./square/gh.svg": 1807,
	"./square/gi.svg": 1808,
	"./square/gl.svg": 1809,
	"./square/gm.svg": 1810,
	"./square/gn.svg": 1811,
	"./square/gp.svg": 1812,
	"./square/gq.svg": 1813,
	"./square/gr.svg": 1814,
	"./square/gs.svg": 1815,
	"./square/gt.svg": 1816,
	"./square/gu.svg": 1817,
	"./square/gw.svg": 1818,
	"./square/gy.svg": 1819,
	"./square/hk.svg": 1820,
	"./square/hm.svg": 1821,
	"./square/hn.svg": 1822,
	"./square/hr.svg": 1823,
	"./square/ht.svg": 1824,
	"./square/hu.svg": 1825,
	"./square/ic.svg": 1826,
	"./square/id.svg": 1827,
	"./square/ie.svg": 1828,
	"./square/il.svg": 1829,
	"./square/im.svg": 1830,
	"./square/in.svg": 1831,
	"./square/io.svg": 1832,
	"./square/iq.svg": 1833,
	"./square/ir.svg": 1834,
	"./square/is.svg": 1835,
	"./square/it.svg": 1836,
	"./square/je.svg": 1837,
	"./square/jm.svg": 1838,
	"./square/jo.svg": 1839,
	"./square/jp.svg": 1840,
	"./square/ke.svg": 1841,
	"./square/kg.svg": 1842,
	"./square/kh.svg": 1843,
	"./square/ki.svg": 1844,
	"./square/km.svg": 1845,
	"./square/kn.svg": 1846,
	"./square/kp.svg": 1847,
	"./square/kr.svg": 1848,
	"./square/kw.svg": 1849,
	"./square/ky.svg": 1850,
	"./square/kz.svg": 1851,
	"./square/la.svg": 1852,
	"./square/lb.svg": 1853,
	"./square/lc.svg": 1854,
	"./square/li.svg": 1855,
	"./square/lk.svg": 1856,
	"./square/lr.svg": 1857,
	"./square/ls.svg": 1858,
	"./square/lt.svg": 1859,
	"./square/lu.svg": 1860,
	"./square/lv.svg": 1861,
	"./square/ly.svg": 1862,
	"./square/ma.svg": 1863,
	"./square/mc.svg": 1864,
	"./square/md.svg": 1865,
	"./square/me.svg": 1866,
	"./square/mf.svg": 1867,
	"./square/mg.svg": 1868,
	"./square/mh.svg": 1869,
	"./square/mk.svg": 1870,
	"./square/ml.svg": 1871,
	"./square/mm.svg": 1872,
	"./square/mn.svg": 1873,
	"./square/mo.svg": 1874,
	"./square/mp.svg": 1875,
	"./square/mq.svg": 1876,
	"./square/mr.svg": 1877,
	"./square/ms.svg": 1878,
	"./square/mt.svg": 1879,
	"./square/mu.svg": 1880,
	"./square/mv.svg": 1881,
	"./square/mw.svg": 1882,
	"./square/mx.svg": 1883,
	"./square/my.svg": 1884,
	"./square/mz.svg": 1885,
	"./square/na.svg": 1886,
	"./square/nc.svg": 1887,
	"./square/ne.svg": 1888,
	"./square/nf.svg": 1889,
	"./square/ng.svg": 1890,
	"./square/ni.svg": 1891,
	"./square/nl.svg": 1892,
	"./square/no.svg": 1893,
	"./square/np.svg": 1894,
	"./square/nr.svg": 1895,
	"./square/nu.svg": 1896,
	"./square/nz.svg": 1897,
	"./square/om.svg": 1898,
	"./square/pa.svg": 1899,
	"./square/pe.svg": 1900,
	"./square/pf.svg": 1901,
	"./square/pg.svg": 1902,
	"./square/ph.svg": 1903,
	"./square/pk.svg": 1904,
	"./square/pl.svg": 1905,
	"./square/pm.svg": 1906,
	"./square/pn.svg": 1907,
	"./square/pr.svg": 1908,
	"./square/ps.svg": 1909,
	"./square/pt.svg": 1910,
	"./square/pw.svg": 1911,
	"./square/py.svg": 1912,
	"./square/qa.svg": 1913,
	"./square/re.svg": 1914,
	"./square/ro.svg": 1915,
	"./square/rs.svg": 1916,
	"./square/ru.svg": 1917,
	"./square/rw.svg": 1918,
	"./square/sa.svg": 1919,
	"./square/sb.svg": 1920,
	"./square/sc.svg": 1921,
	"./square/sd.svg": 1922,
	"./square/se.svg": 1923,
	"./square/sg.svg": 1924,
	"./square/sh.svg": 1925,
	"./square/si.svg": 1926,
	"./square/sj.svg": 1927,
	"./square/sk.svg": 1928,
	"./square/sl.svg": 1929,
	"./square/sm.svg": 1930,
	"./square/sn.svg": 1931,
	"./square/so.svg": 1932,
	"./square/sr.svg": 1933,
	"./square/ss.svg": 1934,
	"./square/st.svg": 1935,
	"./square/sv.svg": 1936,
	"./square/sx.svg": 1937,
	"./square/sy.svg": 1938,
	"./square/sz.svg": 1939,
	"./square/ta.svg": 1940,
	"./square/tc.svg": 1941,
	"./square/td.svg": 1942,
	"./square/tf.svg": 1943,
	"./square/tg.svg": 1944,
	"./square/th.svg": 1945,
	"./square/tj.svg": 1946,
	"./square/tk.svg": 1947,
	"./square/tl.svg": 1948,
	"./square/tm.svg": 1949,
	"./square/tn.svg": 1950,
	"./square/to.svg": 1951,
	"./square/tr.svg": 1952,
	"./square/tt.svg": 1953,
	"./square/tv.svg": 1954,
	"./square/tw.svg": 1955,
	"./square/tz.svg": 1956,
	"./square/ua.svg": 1957,
	"./square/ug.svg": 1958,
	"./square/um.svg": 1959,
	"./square/un.svg": 1960,
	"./square/us.svg": 1961,
	"./square/uy.svg": 1962,
	"./square/uz.svg": 1963,
	"./square/va.svg": 1964,
	"./square/vc.svg": 1965,
	"./square/ve.svg": 1966,
	"./square/vg.svg": 1967,
	"./square/vi.svg": 1968,
	"./square/vn.svg": 1969,
	"./square/vu.svg": 1970,
	"./square/wf.svg": 1971,
	"./square/ws.svg": 1972,
	"./square/xk.svg": 1973,
	"./square/xx.svg": 1974,
	"./square/ye.svg": 1975,
	"./square/yt.svg": 1976,
	"./square/za.svg": 1977,
	"./square/zm.svg": 1978,
	"./square/zw.svg": 1979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1713;